var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInstantWin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9372_70113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49265 0C3.79825 0.00406358 -0.00406033 3.81292 3.25407e-06 8.50735C0.00406684 13.2018 3.81292 17.0041 8.50736 17C13.1989 16.9959 17 13.1916 17 8.50002C16.9919 3.80606 13.1866 0.00402915 8.49265 0ZM11.9823 7.65514L11.975 7.66247L8.669 13.6426C8.60857 13.7567 8.48955 13.8275 8.36045 13.8262H8.25758C8.10248 13.7766 8.00003 13.6289 8.00781 13.4663L8.17679 9.90316H5.31162C5.18899 9.90182 5.07549 9.83814 5.0104 9.73418C4.94587 9.62549 4.94587 9.49022 5.0104 9.38154L8.31637 3.35735C8.39585 3.21009 8.56631 3.13705 8.72779 3.18103C8.88134 3.23279 8.98283 3.37904 8.97756 3.541L8.81591 7.10414H11.6811C11.808 7.10394 11.9243 7.17488 11.9823 7.2878C12.0586 7.39837 12.0586 7.54459 11.9823 7.65514Z",
    fill: "#CCD6F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9372_70113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInstantWin);
export default ForwardRef;